import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as Icons from '@element-plus/icons-vue' // 引入所有图标，并命名为 Icons
import locale from 'element-plus/dist/locale/zh-cn.mjs'
// 2. 引入组件样式
import './assets/index.less'
const app = createApp(App)
for (let i in Icons) {
  app.component(i, Icons[i])
}
app.use(ElementPlus, { locale })
app.use(router)
app.use(store)
app.mount('#app')
